import type { MutableRefObject } from 'react';
import styled from '@emotion/styled';
import { useDiscovery } from '../context';
import FilterValueRenderer from '../FilterValueRenderer';

const CustomValueWrapper = styled.div`
  padding: 0 8px 8px;
  flex: 1;
  overflow: auto;
`;

interface FilterValueContainerProps {
  popupContainerRef?: MutableRefObject<HTMLElement | null>;
}

const FilterValueContainer = ({ popupContainerRef }: FilterValueContainerProps = {}) => {
  const { selectedFilterKey, filters, pendingValues, setPendingValue, layout } = useDiscovery();

  const selectedFilter = filters.find(filter => filter.key === selectedFilterKey);

  const renderFilterByType = () => {
    if (!selectedFilter) return null;

    return (
      <CustomValueWrapper>
        <FilterValueRenderer
          filter={selectedFilter}
          pendingValues={pendingValues}
          setPendingValue={setPendingValue}
          layout={layout}
          popupContainerRef={popupContainerRef}
        />
      </CustomValueWrapper>
    );
  };

  return renderFilterByType();
};

export default FilterValueContainer;
